import { useState } from "react";
import { Link } from "react-router-dom";
import { useGetFaqsQuery } from "../store/api/contentApi";

function FAQItem({ question, answer }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="bg-white mb-2 p-4 rounded-[8px]">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between"
      >
        <span className="font-manrope-semibold text-base text-black text-left">
          {question}
        </span>
        <span className="text-secondary text-xl leading-none flex-shrink-0 ml-4">
          {open ? "−" : "+"}
        </span>
      </button>
      {open && (
        <p className="font-manrope-regular text-base text-black pb-4 leading-relaxed mt-2">
          {answer}
        </p>
      )}
    </div>
  );
}

export default function FAQ() {
  const { data: faqRes, isLoading, isError } = useGetFaqsQuery();
  const faqs = faqRes?.data || [];

  return (
    <div>
      {/* Hero */}
      <div className="relative bg-[#1a7b7b]">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div
            className="absolute -top-10 -right-10 w-52 md:w-72 opacity-80"
            style={{
              background: "linear-gradient(135deg, #a8edea 0%, #fed6e3 40%, #c3f0e8 70%, #b8d4f8 100%)",
              borderRadius: "30% 70% 70% 30% / 30% 30% 70% 70%",
              height: "220px",
              filter: "blur(2px)",
            }}
          />
          <div
            className="absolute -bottom-10 -left-10 w-40 md:w-56 opacity-50"
            style={{
              background: "linear-gradient(135deg, #c3f0e8 0%, #a8edea 50%, #fed6e3 100%)",
              borderRadius: "70% 30% 30% 70% / 70% 70% 30% 30%",
              height: "180px",
              filter: "blur(2px)",
            }}
          />
        </div>
        <div className="container mx-auto px-4 py-14 md:py-20 flex flex-col items-center gap-4 relative z-10">
          <div className="flex flex-wrap items-center justify-center gap-1 text-white/70 font-manrope-regular text-sm">
            <Link to="/" className="hover:text-white transition-colors">Home</Link>
            <span>/</span>
            <span className="text-white">FAQ</span>
          </div>
          <h1 className="font-manrope-bold text-[28px] md:text-[48px] text-white text-center">
            Frequently Asked Questions
          </h1>
          <p className="font-manrope-regular text-sm text-white/70 text-center max-w-md">
            Got questions? We have the answers.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="bg-bg py-12 md:py-16">
        <div className="container mx-auto px-4 max-w-3xl">
          {isLoading && (
            <div className="flex flex-col gap-3">
              {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="bg-white rounded-lg h-14 animate-pulse" />
              ))}
            </div>
          )}

          {isError && (
            <p className="font-manrope-regular text-base text-secondary text-center py-12">
              Failed to load FAQs. Please try again later.
            </p>
          )}

          {!isLoading && !isError && faqs.length === 0 && (
            <p className="font-manrope-regular text-base text-secondary text-center py-12">
              No FAQs available yet.
            </p>
          )}

          {!isLoading && !isError && faqs.length > 0 && (
            <div>
              {faqs.map((faq) => (
                <FAQItem key={faq.id || faq._id} question={faq.question} answer={faq.answer} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
